import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import BannersContent from "modules/Banners";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const BannersPage: React.FC = () => {
  setTitle("Banner Management");
  return (
    <Auth>
      <Layout>
        <BannersContent />
      </Layout>
    </Auth>
  );
};

export default BannersPage;
